import { useTranslation } from "react-i18next";

import OpenButton from "../../../ui/components/OpenButton/OpenButton";

import CreateExportForm from "./CreateExportForm";

export default function CreateExportButton({ article, artifact, publisher }) {
	const { t } = useTranslation();

	return (
		<OpenButton text={t("createExport", "Create export")}>
			{({ setOpen }) => (
				<CreateExportForm
					article={article}
					artifact={artifact}
					publisher={publisher}
					onClose={() => setOpen(false)}
				/>
			)}
		</OpenButton>
	);
}
